import { render, staticRenderFns } from "./QualityMetricsCCF.vue?vue&type=template&id=5b10609b&scoped=true&"
import script from "./QualityMetricsCCF.vue?vue&type=script&lang=js&"
export * from "./QualityMetricsCCF.vue?vue&type=script&lang=js&"
import style0 from "./QualityMetricsCCF.vue?vue&type=style&index=0&id=5b10609b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10609b",
  null
  
)

export default component.exports